import { Link } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/24/outline";
import {
  topicAccentHex,
  topicCtaGradientStyle,
} from "../../../utils/topicBranding";
import type { ModuleI, ToolboxCheckinDefinitionI } from "../../../types";

interface Props {
  topic: ModuleI;
  checkinDefinition?: ToolboxCheckinDefinitionI;
}

export default function CheckInCta({ topic, checkinDefinition }: Props) {
  return (
    <div
      className="rounded-xl p-5 text-white"
      style={topicCtaGradientStyle(topic.color)}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-lg font-bold">
            {checkinDefinition?.ratingLabel ?? "How are you feeling?"}
          </h2>
          <p className="text-sm text-white/80 mt-1">
            Start tracking to see patterns in your {topic.title} toolbox over
            time.
          </p>
        </div>
        <Link
          to="check-ins/new"
          className="inline-flex items-center justify-center font-bold h-10 text-base rounded-md transition-all duration-150 ease-in-out whitespace-nowrap shadow bg-white border-2 !border-white hover:bg-white/90 py-2 px-4"
          style={{ color: topicAccentHex(topic.color) }}
        >
          <PlusIcon className="w-4 h-4 mr-1.5" />
          Check In
        </Link>
      </div>
    </div>
  );
}
